import React from 'react';
import { Clickable, LoadingBalls } from '@moda/om';
import classNames from 'classnames';
import ChevronLeftIcon from '@moda/icons/chevron-left-16';
import ChevronRightIcon from '@moda/icons/chevron-right-16';
import { space } from '@moda/tokens';
import { useIsScrollable, useNode } from '@moda/portal-stanchions';
import { VariantCell } from '../../Grid/GridCell/VariantCell';
import { useLook } from '../useLook';

import './LooksCarouselItemVariants.scss';

const MEDIUM_SIZE = 4;
const ARROW_SIZE = space.scale[MEDIUM_SIZE];

interface Props {
  lookId: string;
}

export const LooksCarouselItemVariants: React.FC<Props> = ({ lookId }) => {
  const { variants, loading } = useLook(lookId);
  const { ref, node } = useNode();

  const { isScrollable, scrollLeft, scrollRight, isMaxLeft, isMaxRight } = useIsScrollable(node);

  if (loading) {
    return (
      <div className="LooksCarouselItemVariants__loading">
        <LoadingBalls />
      </div>
    );
  }

  return (
    <div className="LooksCarouselItemVariants">
      {isScrollable && (
        <Clickable
          className={classNames(
            'LooksCarouselItemVariants__arrow',
            'LooksCarouselItemVariants__arrow--left',
            {
              'LooksCarouselItemVariants__arrow--disabled': isMaxLeft
            }
          )}
          disabled={isMaxLeft}
          onClick={scrollLeft}
          onKeyDown={scrollLeft}
          tabIndex={isMaxRight ? -1 : 0}
        >
          <ChevronLeftIcon width={ARROW_SIZE} height={ARROW_SIZE} />
        </Clickable>
      )}

      <div className="LooksCarouselItemVariants__items" ref={ref}>
        {variants.map(
          variant =>
            variant && (
              <VariantCell
                className="LooksCarouselItemVariants__item"
                key={variant?.id}
                variant={variant}
              />
            )
        )}
      </div>

      {isScrollable && (
        <Clickable
          className={classNames(
            'LooksCarouselItemVariants__arrow',
            'LooksCarouselItemVariants__arrow--right',
            {
              'LooksCarouselItemVariants__arrow--disabled': isMaxRight
            }
          )}
          disabled={isMaxRight}
          onClick={scrollRight}
          onKeyDown={scrollRight}
          tabIndex={isMaxRight ? -1 : 0}
        >
          <ChevronRightIcon width={ARROW_SIZE} height={ARROW_SIZE} />
        </Clickable>
      )}
    </div>
  );
};
